import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as styles from './PageHeader.module.scss'
import Button from '../common/Button'

const PageHeader = ({ title, subtitle }) => {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.heading}>
            <div className={styles.headerTag}>
              <span>Built with</span>
              <img src="https://atlas.co/brand/atlas-logo.png" alt="Atlas" />
            </div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
    </>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default PageHeader
